import { useState, useEffect } from 'react';
import { adminSellersAPI } from './adminApi';
import s from './AdminSellers.module.css';

const ST = {
  pending:  { bg:'#F59E0B18', color:'#F59E0B', label:'Pending'  },
  approved: { bg:'#10B98118', color:'#10B981', label:'Approved' },
  declined: { bg:'#EF444418', color:'#EF4444', label:'Declined' },
};

export default function AdminSellers() {
  const [sellers,  setSellers]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [filter,   setFilter]   = useState('all');
  const [expanded, setExpanded] = useState(null);
  const [acting,   setActing]   = useState(null);
  const [declineId, setDeclineId] = useState(null);
  const [reason,   setReason]   = useState('');

  useEffect(() => {
    adminSellersAPI.list({ per_page: 100 })
      .then(res => setSellers(res.data.sellers || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const approve = async (id) => {
    setActing(id);
    try {
      await adminSellersAPI.approve(id);
      setSellers(prev => prev.map(s => s.id === id ? { ...s, status: 'approved' } : s));
    } catch { alert('Failed'); }
    finally { setActing(null); }
  };

  const decline = async (id) => {
    setActing(id);
    try {
      await adminSellersAPI.decline(id, reason);
      setSellers(prev => prev.map(s => s.id === id ? { ...s, status: 'declined', declineReason: reason } : s));
      setDeclineId(null); setReason('');
    } catch { alert('Failed'); }
    finally { setActing(null); }
  };

  const filtered = sellers.filter(s => filter === 'all' || s.status === filter);

  if (loading) return <div className={s.loading}><div className={s.spin} /></div>;

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Sellers</h1>
        <p className={s.sub}>{sellers.length} applications</p>
      </div>

      <div className={s.filters}>
        {['all','pending','approved','declined'].map(f => (
          <button key={f} className={`${s.filter} ${filter === f ? s.filterActive : ''}`} onClick={() => setFilter(f)}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
            <span className={s.fcount}>{f === 'all' ? sellers.length : sellers.filter(x => x.status === f).length}</span>
          </button>
        ))}
      </div>

      <div className={s.list}>
        {filtered.length === 0 && <p className={s.empty}>No sellers found</p>}
        {filtered.map(seller => {
          const st = ST[seller.status] || ST.pending;
          return (
            <div key={seller.id} className={s.card}>
              <div className={s.row} onClick={() => setExpanded(expanded === seller.id ? null : seller.id)}>
                <div className={s.avatar}>{seller.businessName?.charAt(0) || 'S'}</div>
                <div className={s.main}>
                  <p className={s.bname}>{seller.businessName}</p>
                  <p className={s.bmeta}>{seller.category} · {seller.state} · <strong>{seller.sellerId}</strong></p>
                </div>
                <span className={s.badge} style={{ background: st.bg, color: st.color }}>{st.label}</span>
                <span className={s.chev}>{expanded === seller.id ? '▲' : '▼'}</span>
              </div>

              {expanded === seller.id && (
                <div className={s.detail}>
                  <div className={s.dGrid}>
                    <div><p className={s.dLabel}>Contact</p><p className={s.dVal}>{seller.phone}</p><p className={s.dVal}>{seller.businessEmail}</p></div>
                    <div><p className={s.dLabel}>Address</p><p className={s.dVal}>{seller.address}</p><p className={s.dVal}>{seller.location}, {seller.state}</p></div>
                    <div><p className={s.dLabel}>Bank</p><p className={s.dVal}>{seller.bankName}</p><p className={s.dVal}>{seller.accountNumber} — {seller.accountName}</p></div>
                    <div><p className={s.dLabel}>ID Verification</p><p className={s.dVal}>{seller.idType?.toUpperCase()}: {seller.idNumber}</p></div>
                  </div>

                  {seller.status === 'declined' && seller.declineReason && (
                    <div className={s.dNote}>❌ {seller.declineReason}</div>
                  )}

                  {seller.status === 'pending' && (
                    declineId === seller.id ? (
                      <div className={s.declineForm}>
                        <textarea className={s.reasonInput} placeholder="Reason for declining…" value={reason} onChange={e => setReason(e.target.value)} rows={2} />
                        <div className={s.declineBtns}>
                          <button className={s.cancelBtn} onClick={() => { setDeclineId(null); setReason(''); }}>Cancel</button>
                          <button className={s.confirmDeclineBtn} onClick={() => decline(seller.id)} disabled={acting === seller.id || !reason.trim()}>
                            {acting === seller.id ? '…' : 'Confirm Decline'}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className={s.actions}>
                        <button className={s.approveBtn} onClick={() => approve(seller.id)} disabled={acting === seller.id}>
                          {acting === seller.id ? '…' : '✅ Approve seller'}
                        </button>
                        <button className={s.declineBtn} onClick={() => setDeclineId(seller.id)}>❌ Decline</button>
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
